import Crypto from 'crypto-js'

// DO NOT CHANGE these constants to keep local storage data for clients
const encryptionToken = '88ab1ddd-be08-48f3-acae-dd465fe7afc0'
const userKey = 'user'
const guestKey = 'guest'
const initialTimestampKey = 'initialts'
const elapsedSecondsKey = 'elapsedseconds'
const questionsKey = 'qdata'
const competenciesKey = 'cdata'
const answersKey = 'adata'
const userScoreKey = 'user-score'


function setEncryptedStorageData(key, data) {
  localStorage.setItem(key, Crypto.AES.encrypt(JSON.stringify(data), encryptionToken).toString())
}

function getEncryptedStorageData(key) {
  const data = localStorage.getItem(key)
  if (!data) {
    return null
  }
  return JSON.parse(Crypto.AES.decrypt(data, encryptionToken).toString(Crypto.enc.Utf8))
}

function getUser() {
    const user = localStorage.getItem(userKey) || '{}'
    return JSON.parse(user)
}

function setUser(user) {
    localStorage.setItem(userKey, JSON.stringify(user))
}

function setQuestions(questions) {
  setEncryptedStorageData(questionsKey, questions)
}

function getQuestions() {
  return getEncryptedStorageData(questionsKey)
}

function setCompetencies(competencies) {
  setEncryptedStorageData(competenciesKey, competencies)
}

function getCompetencies() {
  return getEncryptedStorageData(competenciesKey)
}

function setAnswers(answers) {
  setEncryptedStorageData(answersKey, answers)
}

function getAnswers() {
  return getEncryptedStorageData(answersKey)
}

function removeItemAnswers() {
  localStorage.removeItem(answersKey)
  localStorage.removeItem(elapsedSecondsKey)
}

function setGuest(guest) {
  localStorage.setItem(guestKey, JSON.stringify(guest))
}

function getGuest() {
  return JSON.parse(localStorage.getItem(guestKey)) || '{}'
}

function removeGuest() {
  localStorage.removeItem(guestKey)
}

function clearAll() {
  localStorage.removeItem(userKey)
  localStorage.removeItem(guestKey)
  localStorage.removeItem(initialTimestampKey)
  localStorage.removeItem(elapsedSecondsKey)
  localStorage.removeItem(questionsKey)
  localStorage.removeItem(competenciesKey)
  localStorage.removeItem(answersKey)
  clearUserScore()
}

function setInitialTimestamp(timestamp) {
  localStorage.setItem(initialTimestampKey, timestamp.toString())
}

function getInitialTimestamp() {
  const timestampString = localStorage.getItem(initialTimestampKey)
  if (timestampString) {
    return parseInt(timestampString)
  }
  return null
}

function setElapsedSeconds(seconds) {
  localStorage.setItem(elapsedSecondsKey, seconds.toString())
}

function getElapsedSeconds() {
  const secondsString = localStorage.getItem(elapsedSecondsKey)
  if (secondsString) {
    return parseInt(secondsString)
  }
  return null
}

function saveUserScore(score) {
  localStorage.setItem(userScoreKey, score)
}

function getUserScore() {
  const score = localStorage.getItem(userScoreKey)
  if (score === undefined || score === null) {
    return false
  }
  return parseInt(score)
}

function clearUserScore() {
  localStorage.removeItem(userScoreKey)
}



export default {
  getUser,
  setUser,
  setQuestions,
  getQuestions,
  setAnswers,
  getAnswers,
  removeItemAnswers,
  clearAll,
  setCompetencies,
  getCompetencies,
  setInitialTimestamp,
  getInitialTimestamp,
  setElapsedSeconds,
  getElapsedSeconds,
  setGuest,
  getGuest,
  removeGuest,
  saveUserScore,
  getUserScore,
  clearUserScore
}
